import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import { SiteService } from "../../../services/site.service";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
}));

const SiteEdition = ({ onClose, open, info, updateDirection, id }) => {
  const classes = useStyles();
  const [editSite, setEditSite] = useState({
    direction: info.direction,
    name: info.name,
    cp: info.cp,
    serie: info.serie,
  });

  const handleClose = () => onClose();

  const handleSubmitForm = async () => {
    try {
      const result = await SiteService.updateSiteById(id, editSite);
      if (result.status === 201) {
        updateDirection(true);
      }
    } catch (error) {
      console.log("error UPDATE siteById", error);
      updateDirection(false, error.msgs);
    }
    onClose();
  };

  const handleInputText = ({ target: { name, value } }) => {
    setEditSite({ ...editSite, [name]: value });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Editar sucursal
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Nombre
              </Typography>
              <TextField
                name="name"
                value={editSite.name}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Dirección
              </Typography>
              <TextField
                name="direction"
                value={editSite.direction}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Código Postal
              </Typography>
              <TextField
                name="cp"
                value={editSite.cp}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Serie factura
              </Typography>
              <TextField
                name="serie"
                autoComplete="off"
                value={editSite.serie}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>

          <ConfirmButtons
            handleSubmitForm
            cancel={() => onClose()}
            accept={handleSubmitForm}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default SiteEdition;
